import { render, staticRenderFns } from "./HistoryOderKidsDialogGroup.vue?vue&type=template&id=72f918e2&scoped=true"
import script from "./HistoryOderKidsDialogGroup.vue?vue&type=script&lang=js"
export * from "./HistoryOderKidsDialogGroup.vue?vue&type=script&lang=js"
import style0 from "./HistoryOderKidsDialogGroup.vue?vue&type=style&index=0&id=72f918e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f918e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f918e2')) {
      api.createRecord('72f918e2', component.options)
    } else {
      api.reload('72f918e2', component.options)
    }
    module.hot.accept("./HistoryOderKidsDialogGroup.vue?vue&type=template&id=72f918e2&scoped=true", function () {
      api.rerender('72f918e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByGroup/GroupExcelTableDialog/HistoryOderKidsDialogGroup.vue"
export default component.exports